import InteractiveMapContainer from './InteractiveMapContainer';

export default InteractiveMapContainer;
